function Services() {
  const services = [
    {
      title: "Structural Rebar Detailing",
      description:
        "Producing precise reinforcement detailing that meets rigorous project specifications, structural design layouts, and international industry standards.",
    },
    {
      title: "Bar Bending Schedules (BBS)",
      description:
        "Developing accurate and highly optimized schedules engineered specifically to minimize steel scrap, reduce project costs, and speed up site placement.",
    },
    {
      title: "Shop Drawings",
      description:
        "Generating clear, code-compliant fabrication blueprints and detailed construction drawings that facilitate seamless structural project execution.",
    },
    {
      title: "MEP BIM Coordination",
      description:
        "Creating fully coordinated Building Information Models (BIM) that integrate Mechanical, Electrical, and Plumbing systems with structural and architectural components.",
    },
    {
      title: "Clash-Free Engineering Models",
      description:
        "Bridging the gap between design and construction by delivering fully integrated, clash-free models that ensure seamless structural integrity and flawless building performance.",
    },
    {
      title: "Quantity Take-Off & Documentation",
      description:
        "Accurate material quantity extractions and comprehensive engineering documentation to eliminate rework and support cost-effective execution across residential, commercial, industrial, and infrastructure sectors.",
    },
  ];

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">

        <div className="text-center mb-16">
          <p className="uppercase tracking-[4px] text-[#C8A96B] font-semibold">
            Our Expertise
          </p>

          <h1 className="text-5xl font-bold text-[#0A1A3F] mt-4">
            Capabilities
          </h1>

          <p className="max-w-3xl mx-auto mt-6 text-slate-600 text-lg leading-relaxed">
            Vamco Architectural Prospective Drawings Services LLC, together with our trusted associates Falcosys Infotech Ltd and Astra Engineering Consultants, delivers high-quality engineering solutions that support efficient, accurate, and cost-effective project execution.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-sm border border-slate-200 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 flex flex-col justify-between"
            >
              <div>
                <div className="w-14 h-14 rounded-lg bg-[#0A1A3F] text-white flex items-center justify-center text-xl font-bold mb-6">
                  0{index + 1}
                </div>

                <h3 className="text-2xl font-bold text-[#0A1A3F] mb-4">
                  {service.title}
                </h3>

                <p className="text-slate-600 leading-relaxed font-light">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Services;